import React, {FC} from "react"
import {Container} from "./styled"

interface Props {
  bgColor?: string,
  color?: string,
  uppercase?: boolean,
  weight?: "default" | "light" | "semibold" | "bold",
  padding?: string | number | (number | string)[]
  margin?: string | number | (number | string)[]
}

const Badge: FC<Props> = ({children, color, bgColor, uppercase, weight, padding, margin}) => (
  <Container
    color={color}
    bgColor={bgColor}
    uppercase={uppercase}
    weight={weight}
    padding={padding}
    margin={margin}>
    {children}
  </Container>
)


export default Badge
